let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCyS0")).then(() => parcelRequire('d9nVP'));